export * from "/vercel/path0/node_modules/i18next/dist/esm/i18next.js"